import { Directive, HostListener, ElementRef, Output, EventEmitter, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * Force la saisie arabe uniquement dans un input (frappe + collage).
 * - Si l'input est li� � un NgControl (ngModel/formControl), met � jour le contr�le.
 * - Sinon, �met la valeur filtr�e via (arabicValue) pour les bindings � base de signal:
 *     <input appArabicOnly [value]="nomAr()" (arabicValue)="nomAr.set($event)">
 */
@Directive({
  selector: '[appArabicOnly]',
  standalone: false
})
export class ArabicOnlyDirective {
  private el = inject(ElementRef);
  private ngControl = inject(NgControl, { optional: true });

  @Output() arabicValue = new EventEmitter<string>();

  // Lettres arabes + espace, tiret, apostrophe
  private arabicRegex = /[؀-ۿݐ-ݿﭐ-﷿ﹰ-﻿\s\-']/;

  @HostListener('input', ['$event']) onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const filtered = this.filter(input.value);
    if (filtered !== input.value) {
      const pos = input.selectionStart || 0;
      input.value = filtered;
      const back = Math.max(0, pos - 1);
      setTimeout(() => input.setSelectionRange(back, back));
    }
    this.sync(filtered);
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pasted = this.filter(event.clipboardData?.getData('text') || '');
    if (!pasted) return;
    const input = this.el.nativeElement as HTMLInputElement;
    const start = input.selectionStart || 0;
    const end = input.selectionEnd || 0;
    const newValue = input.value.substring(0, start) + pasted + input.value.substring(end);
    input.value = newValue;
    const cursor = start + pasted.length;
    setTimeout(() => input.setSelectionRange(cursor, cursor));
    this.sync(newValue);
  }

  private filter(value: string): string {
    return value.split('').filter(c => this.arabicRegex.test(c)).join('');
  }

  private sync(value: string): void {
    if (this.ngControl) {
      this.ngControl.control?.setValue(value, { emitEvent: false });
    }
    this.arabicValue.emit(value);
  }
}
